/* ==========================================================================
BOUNTEOUS CONFIDENTIAL
___________________

Copyright 2019 Bounteous
All Rights Reserved.

NOTICE:  All information contained herein is, and remains the property
of Bounteous and its suppliers, if any. The intellectual and
technical concepts contained herein are proprietary to Bounteous
and its suppliers and are protected by trade secret or copyright law.
Dissemination of this information or reproduction of this material
is strictly forbidden unless prior written permission is obtained
from Bounteous.
========================================================================== */

import { Component, registerComponent } from 'js/component.js';
import { getBreakpointMediaQuery } from 'js/constants.js';
import { throttle } from 'js/helpers.js';

const componentName = 'cmp-header';

export class Header extends Component {

    /**
    * Check if Mobile Nav is Open
    */
    isNavOpen() {
        return this.elements.hamburger.classList.contains('open')
        && this.elements.nav.classList.contains('open')
        && this.element.classList.contains('open');
    }

    /**
    * Toggle Mobile Nav
    */
    toggleMobileNav() {
        this.elements.body.classList.toggle('mobile-nav-open');
        this.elements.hamburger.classList.toggle('open');
        this.elements.nav.classList.toggle('open');
        this.element.classList.toggle('open');
    }

    /**
     * Remove Extra Open Classes (from navigation children)
     */
    removeOpenClasses() {
        const openEles = this.element.getElementsByClassName('open');
        [...openEles].map((ele) => ele.classList.remove('open'));
    }

    /**
    * Add Event Listeners
    */
    addEventListeners() {
        const classScope = this;

        // On Hamburger Icon Click
        function onHamburgerClick(e) {
            e.preventDefault();
            classScope.toggleMobileNav();
        }

        // On Window Resize
        function onWindowResize() {
            // [LEGACY BREAKPOINT: width > 767px -> getBreakpointMediaQuery('up', 'small')]
            if (getBreakpointMediaQuery('up', 'small').matches && classScope.isNavOpen()) {
                classScope.toggleMobileNav();
                classScope.removeOpenClasses();
            }
        }

        // Assign Listeners
        this.elements.hamburgerWrapper.addEventListener('click', onHamburgerClick);
        window.addEventListener('resize', throttle(() => onWindowResize(), 100));
    }

    /**
    * Initialize Component
    */
    init() {
        // Set Up Elements
        this.elements = {
            body: document.querySelector('body'),
            hamburgerWrapper: this.element.querySelector('.hamburger-wrapper'),
            hamburger: this.element.querySelector('.mobile-nav-icon'),
            nav: this.element.querySelector(`.${componentName}__navbar`),
            searchIcon: this.element.querySelector('.btn-search'),
            searchInput: this.element.querySelector('.cmp-search-box__input'),
        };

        // Set Up Data
        // Fire Init Funcs
        this.addEventListeners();
    }

}

registerComponent(`.${componentName}`, Header);
